import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-google-search-ads-checklist',
  templateUrl: './help-google-search-ads-checklist.component.html'
})
export class HelpGoogleSearchAdsChecklistComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
